var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-table",
    {
      attrs: {
        loading: _vm.loading,
        data: _vm.files,
        bordered: false,
        hoverable: false,
        striped: false,
        scrollable: false
      },
      scopedSlots: _vm._u([
        {
          key: "default",
          fn: function(ref) {
            var row = ref.row
            return [
              _c(
                "sc-table-column",
                { attrs: { label: "Arquivo", centered: false } },
                [_vm._v("\n      " + _vm._s(row.filename) + "\n    ")]
              ),
              _vm._v(" "),
              _c(
                "sc-table-column",
                { attrs: { label: "Fatura", centered: false } },
                [_vm._v("\n      " + _vm._s(row.billingName) + "\n    ")]
              ),
              _vm._v(" "),
              _c(
                "sc-table-column",
                { attrs: { label: "Solicitado em", centered: false } },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm._f("date")(row.createdAt, "DD/MM/YY - HH:mm")
                      ) +
                      "\n    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "sc-table-column",
                { attrs: { label: "Finalizado em", centered: false } },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm._f("date")(row.finishedAt, "DD/MM/YY - HH:mm")
                      ) +
                      "\n    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "sc-table-column",
                { attrs: { label: "Ações", centered: false } },
                [
                  _c(
                    "a",
                    {
                      staticClass: "button is-primary",
                      class: { "is-loading": !row.url },
                      attrs: { href: row.url }
                    },
                    [_vm._v("Download")]
                  )
                ]
              )
            ]
          }
        }
      ])
    },
    [
      _c(
        "template",
        { attrs: { slot: "empty" }, slot: "empty" },
        [
          _c("sc-table-empty", {
            attrs: { icon: "box-open", message: _vm.emptyTableTemplate }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9a39ca1c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a39ca1c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/billing/pages/files/components/BillingExtractionsTable.vue
// module id = null
// module chunks = 